export const ANALYTICS = {
  TOOLTIP: {
    AVG_RESPONSE_TIME:
      'The average time took for the agents to send the first message to the user after accepting the chat request',
    SELECT_TIME: 'Showing results for the selected duration',
    ENGAGEMENTS:
      'The number of engagement indicates at least one message exchange between the visitor and the widget',
    KNOWN_ACCOUNT_VISITS:
      'The accounts which Chat was able to resolve as a Company name or a domain',
    AVG_RESPONSE_TIME_VISIT:
      'The average time took for the agents to send the first message to the user after accepting the chat request, in a single visit',
  },
};

export const PERSONALIZATION_ERROR = {
  EMPTY_FIELD: 'Please select a field',
  EMPTY_DEFAULT: 'Please enter a default value',
};

export const BUILD_CONVERSATION = {
  ALERTS: {
    REDIRECT_CONDITION: "Only one of 'Live Chat, Go to path, Buttons' allowed in a path",
    ALERT_CONDITION: 'Only one alert is allowed in a path',
    REMOVE_PATH: 'Are you sure you want to remove this path?',
    DELETE_CONVERSATION: 'Are you sure you want to delete this conversation?',
    CLONE_CONVERSATION: 'Are you sure you want to clone this conversation?',
    CONVERSATION_STATUS_CHANGE: 'Conversation status changed successfully',
    DELETE_CONVERSATION_SUCCESS: 'Conversation deleted successfully',
    CLONE_CONVERSATION_SUCCESS: 'Conversation cloned successfully',
    SAVE_CONVERSATION_SUCCESS: 'Conversation saved successfully',
    SAVE_AUDIENCE_SUCCESS: 'Audience saved successfully',
    FIRST_PATH_NO_CHANGE: 'The first path cannot be re-ordered or deleted',
    NEW_FIELD_CREATED_SUCCESS: 'New field created successfully',
    ERROR_IN_PATHS: 'Please fix all the errors, to save the conversation flow',
    ERROR_IN_AUDIENCE: 'Missing required fields',
    FORM_NOT_SELECTED: 'Please select a form from the website',
    CONVERSATION_NAME_SUCCESS: 'Conversation name updated successfully',
  },
};
export const CHAT = {
  ALERTS: {
    BOOK_MEETING_START: 'Do you want to start the book meeting flow?',
    AGENTS_ADDED_SUCCESS: 'Added agents to the conversation successfully!',
    REMOVE_AGENT_SUCCESS: 'Removed agent from the conversation successfully!',
    AVAILABLE_STATUS_CHANGE_SUCCESS: 'Updated the availability status successfully!',
    CLOSE_CONVERSATIONS_SUCCESS: 'Closed all the selected conversations successfully!',
    COMPLETE_PROFILE: 'Please complete the profile, to go online',
  },
};

export const ABV = {
  TOOLTIP: {
    HIGHLIGHTS_INTEGRATIONS: {
      salesforce: {
        name: 'salesforce',
        title: 'Integrate Salesforce',
        description: 'Integrate Salesforce and get more work done directly from your highlights',
      },
      hubspot: {
        name: 'hubspot',
        title: 'Integrate Hubspot',
        description: 'Integrate Hubspot and get more work done directly from your highlights',
      },
    },
    HIGHLIGHTS_PRICING: {
      intent: {
        name: 'intent',
        title: 'Unlock Intent',
        description: 'Upgrade to connect Intent and access other exclusive features.',
      },
      technologies: {
        name: 'technologies',
        title: 'Unlock Technologies',
        description: 'Upgrade to connect Technologies and access other exclusive features.',
      },
    },
  },
  ALERTS: {
    MAX_HIGHLIGHTS_FIELDS_SELECTED: '15/15 fields already selected',
  },
};

export const MEETING = {
  ALERTS: {
    SAVED_MEETING_SETTING_SUCCESS: 'Saved meeting setting successfully',
    SAVED_MEETING_AVAILABILITY_SUCCESS: 'Saved meeting availability successfully',
  },
};
export const CONFIGURATIONS = {
  TOOLTIP: {
    SHOW_WIDGET: 'Toggle the visibility of chat widget on your website',
    PERSONALIZATION: 'Toggle the personalization of greeting message',
    OFFLINE_BOT_EXPERIENCE: 'Link to offline bot conversation will be shown here when enabled',
    HOLIDAY_TIMEZONE: 'Timezone is defined in Widget Settings > Behavior',
    HOLIDAY: ' Link to holiday conversation will be shown here when enabled',
  },
  ALERTS: {
    UPDATE_RULE_SUCCESS: 'Updated the rule successfully',
    DELETE_RULE_SUCCESS: 'Deleted the rule successfully',
    UPDATE_RULE_STATUS_SUCCESS: 'Updated the rule status successfully',
    WIDGET_STATUS: 'Status of the widget updated successfully',
    VISITOR_NAME_STATUS: 'Status of the visitor name updated successfully',
    SAVE_BOT_SETTINGS_SUCCESS: 'Updated the widget settings successfully',
    SAVE_PRIVACY_POLICY_SUCCESS: 'Updated the privacy policy settings successfully',
    ADD_FIELD_FUNCTION:
      'Ability to customize and map more fields will be added very soon in an upcoming release',
    MAX_HOLIDAY_LIST: 'Maximum limit of 100 holidays has been reached',
    SAVE_HOLIDAY_LIST: 'Updated the holiday settings successfully',
  },
};
export const CONVERSATIONS = {
  ALERTS: {
    NEW_CONVERSATION_SUCCESS: 'Created new conversation successfully',
  },
};
export const VERIFY_EMAIL = {
  ALERTS: {
    VERIFY_EMAIL_SUCCESS: 'Email verified successfully!',
  },
};
export const FORGOT_PASSWORD = {
  ALERTS: {
    PASSWORD_CHANGE_SUCCESS: 'Password change successfully!',
  },
};
export const HUBSPOT_VERIFY = {
  ALERTS: {
    INTEGRATE_HUBSPOT_SUCCESS: 'Hubspot integrated successfully!',
  },
};
export const MICROSOFT_VERIFY = {
  ALERTS: {
    INTEGRATE_MICROSOFT_SUCCESS: 'Microsoft integrated successfully!',
  },
};
export const GOOGLE_VERIFY = {
  ALERTS: {
    INTEGRATE_GOOGLE_SUCCESS: 'Google integrated successfully!',
  },
};
export const ZENDESK_VERIFY = {
  ALERTS: {
    INTEGRATE_ZENDESK_SUCCESS: 'Zendesk integrated successfully!',
  },
};
export const MSTEAMS_VERIFY = {
  ALERTS: {
    INTEGRATE_HUBSPOT_SUCCESS: 'MS Team integrated successfully!',
  },
};

export const SLACK_VERIFY = {
  ALERTS: {
    INTEGRATE_SLACK_SUCCESS: 'Slack integrated successfully!',
  },
};

export const CONNECT_TO_HUMAN = {
  PARALLEL_NOTE: `( Don't wait for agent response )`,
  SERIAL_NOTE: `( Wait for agent response )`,
};

export const INTEGRATION_PAGE = {
  DESCRIPTION: {
    HUBSPOT:
      'Use your Hubspot lists to build your conversation audience. Sync chat leads to Hubspot.',
    INTEGRATE_SCRIPT:
      'Integrate the below script in your website domain to make chat live. The script should be added at the end of the <body> tag of your HTML.',
    MARKETO:
      'Use your Marketo lists to build your conversation audience. Sync chat leads to Marketo.',
    SALESFORCE: 'Use your Salesforce data to build your conversation audience. ',
    SLACK: "Chat with your website visitors directly from your team's Slack instance.",
    TEAMS: "Chat with your website visitors directly from your team's Microsoft Teams.",
    ZENDESK: 'Enable instant knowledge base search from chat.',
    PARDOT: 'Use your Pardot lists to build your conversation audience. Sync chat leads to Pardot.',
    ELOQUA: 'Use your Eloqua to build your conversation audience. Sync chat leads to Eloqua.',
    ZOHO: 'Use your Zoho data to build your conversation audience.',
    RINGLEAD: 'Use your Ringlead integration for routing.',
    MS_DYNAMICS: 'Use your Microsoft Dynamics CRM data to build your conversation audience.',
  },
  ALERTS: {
    SAVE_CREDENTIAL_SUCCESS: 'Credential saved successfully!',
    RECONNECTION: 'Please reach out to support to reconnect your integration',
    MULTIPLE_MAP:
      'Only one Marketing Automation Platform connection is allowed. Please contact support if you wish to connect additional platforms',
    MSDYNAMICS_SUCCESS: 'Microsoft Dynamics CRM integrated successfully!',
    MSDYNAMICS_ERROR: 'Something went wrong. Please try again',
    TARGET_ACCOUNT_LIST_CREATED_SUCCESS: 'File uploaded successfully',
    TARGET_ACCOUNT_LIST_DELETED_SUCCESS: 'File deleted successfully',
  },
};
export const INVITE = {
  INFO: {
    ACCEPTED_INVITE: 'Successfully accepted the invitation',
    EMAIL_VERIFY_PENDING: 'Email verification of your account is pending. Please check your email',
    CREATE_ACCOUNT_TO_CONTINUE: 'Please create an account to continue',
  },
  ALERTS: {
    INVITE_SUCCESS: 'Invited to project successfully',
  },
};
export const LOGIN_PAGE = {
  ALERTS: {
    NOT_VERIFY: 'Please verify your email to continue',
    LOGIN_SUCCESS: 'Login Success!',
    RESET_PASSWORD: 'We have sent an email to reset your password',
  },
};
export const LOGOUT_PAGE = {
  ALERTS: {
    LOGOUT_SUCCESS: 'Logout Success!',
  },
};
export const PROFILE = {
  ALERTS: {
    SAVE_PROFILE_SUCCESS: 'Updated profile successfully!',
  },
};
export const REGISTER_PAGE = {
  INFO: {
    VERIFY_EMAIL_HEAD: 'A verification link has been sent to your email account',
    VERIFY_EMAIL_DESC:
      'Please click on the link that has just been sent to your email account to verify your email',
  },
  ALERTS: {
    REGISTER_SUCCESS: 'Successfully Register!',
    RESEND_EMAIL_SUCCESS: 'Successfully Resend Email!',
  },
};

export const TEAMS_SUCCESS_PAGE = {
  HEADING: 'Successfully Setup MS Teams',
  BODY:
    'Send alerts to this channel and begin responding to visitors from the Posts tab and the Chat Inbox.',
};

export const TEAM = {
  ALERTS: {
    REMOVE_MEMBER: 'Do you want to remove this member?',
    REMOVE_MEMBER_SUCCESS: 'Removed member successfully!',
    EDIT_MEMBER_SUCCESS: 'Updated member successfully!',
    REMOVE_ROLE: 'Do you want to remove this role?',
    REMOVE_ROLE_SUCCESS: 'Removed role successfully!',
    REMOVE_TEAM: 'Do you want to remove this team?',
    REMOVE_TEAM_SUCCESS: 'Removed team successfully!',
    CLONE_ROLE: 'Do you want to clone this role?',
    CLONE_ROLE_SUCCESS: 'Cloned role successfully!',
    CLONE_TEAM: 'Do you want to clone this team?',
    CLONE_TEAM_SUCCESS: 'Cloned team successfully!',
    UPDATE_ROLE_SUCCESS: 'Updated role successfully!',
    UPDATE_TEAM_SUCCESS: 'Updated team successfully!',
    CREATE_TEAM_SUCCESS: 'Created team successfully!',
    CREATE_ROLE_SUCCESS: 'Created role successfully!',
    ASSIGNED_TEAM_SUCCESS: 'Assigned team successfully!',
    ASSIGNED_ROLE_SUCCESS: 'Assigned role successfully!',
  },
};
export const FORM = {
  ERRORS: {
    ROLE_NAME_REQUIRED: 'Role name is required',
    TEAM_NAME_REQUIRED: 'Team name is required',
    BOT_NAME_REQUIRED: `Bot name is required`,
    PATH_NAME_MIN_LENGTH: 'Path name must be at least 4 characters',
    PATH_NAME_MAX_LENGTH: `Path name must be at most 40 characters`,
    PATH_NAME_REQUIRED: 'Path name is required',
    NAME_MIN_LENGTH: 'Name should contain a minimum of 2 characters',
    NAME_MAX_LENGTH: 'Name must be at most 50 characters',
    COMPANY_MIN_LENGTH: 'Company should contain a minimum of 2 characters',
    COMPANY_MAX_LENGTH: 'Company must be at most 50 characters',
    COMPANY_REQUIRED: 'Company name required',
    DESCRIPTION_MIN_LENGTH: 'Description should contain a minimum of 2 characters',
    DESCRIPTION_MAX_LENGTH: 'Description must be at most 120 characters',
    DESCRIPTION_REQUIRED: 'Description is required',
    VALID_IMAGE_URL: 'Please enter a valid image URL',
    MIN_ONE_FROM_LIST: 'Please select atleast one list from the dropdown',
    VALUE_REQUIRED: 'Please enter a value',
    RULE_NAME_REQUIRED: 'Rule name is required',
    SOURCE_REQUIRED: 'Source is required',
    FIELD_NAME_REQUIRED: 'Chat field name is required',
    FIELD_TYPE_REQUIRED: 'Chat field type is required',
    CLIENT_ID_REQUIRED: 'Client Id is a required field',
    CLIENT_SECRET_REQUIRED: 'Client secret is a required field',
    BASE_URL_REQUIRED: 'Base URL is a required field',
    NAME_REQUIRED: 'Name is required',
    LINKEDIN_URL_VALID: 'Please enter a valid LinkedIn URL',
    LINKEDIN_URL_REQUIRED: 'LinkedIn URL is required',
    TITLE_REQUIRED: 'Title is required',
    TITLE_MIN_LENGTH: 'Title should contain atleast one character',
    TITLE_MAX_LENGTH: 'Title must be at most 50 characters',
    VALID_CALENDAR_LINK: 'Please enter a valid calendar link',
    CALENDAR_LINK_REQUIRED: 'Calender link is required',
    IMAGE_URL_REQUIRED: 'Image is required',
    PHONE_REQUIRED: 'Phone number is required',
    AUDIENCE_NAME_REQUIRED: 'Audience name is required',
    DOMAIN_REQUIRED: 'Domain is required',
    API_KEY_REQUIRED: 'Api key is required',
    HOLIDAY_NAME_REQUIRED: 'Holiday name required',
    DUPLICATE_HOLIDAY_NAME: 'Contains duplicate holiday name',
    HOLIDAY_DATE_REQUIRED: 'Holiday date required',
    DUPLICATE_HOLIDAY_DATE: 'Contains duplicate holiday date',
  },
};

export const COMMON = {
  SLACK_ALERT: 'Slack alerts will be disabled, if no channels are selected',
  SLACK_NOT_INTEGRATED: 'Please integrate slack to enable this field',
  ERRORS: {
    SOMETHING_WENT_WRONG: ' Something went wrong. Please try again!',
  },
};

export const FIEDL_MAPPING_PAGE = {
  DEFAULT: 'Saved successfully',
  FIELD_SAVE: 'Field saved successfully',
  FIELD_DELETE: 'Field deleted successfully',
  FIELD_STATUS_TOGGLE: 'Field status updated successfully',
  FIELD_IF_MISSING_TOGGLE: 'Field overwrite behavior updated successfully',
};

export const PERMISSION_MESSAGE = {
  NOT_AUTHORIZED: 'You are not authorized',
  DISABLE_HOLIDAY_STATUS: 'Holiday conversation is enabled/disabled based on holiday settings',
  DISABLE_OFFLINE_STATUS:
    'Offline conversation is enabled/disabled based on offline experience settings',
};

export const ZENDESK_INBOX = {
  ALERTS: {
    ZENDESK_TICKET_SUCCESS: 'Ticket created successfully in Zendesk with Ticket ID: ',
  },
};

export const SERVICE_CLOUD = {
  ALERTS: {
    SERVICE_CLOUD_CASE_CREATION_SUCCESS:
      'Case created successfully in Service cloud with Case ID: ',
  },
};

export const UNLOCK_SCREEN = {
  INTENT: {
    title: 'Subscribe to Intent',
    subTitle: 'Uncover insights on your target accounts, not readily available on the web.',
  },
  SCOOPS: {
    title: 'Subscribe to Scoops',
    subTitle: 'Uncover scoops on your target accounts, not readily available on the web.',
  },
  TECHNOLOGIES: {
    title: 'Subscribe to Technologies',
    subTitle: 'Uncover technologies of your target accounts, not readily available on the web.',
  },
};

export const HIGHLIGHTS_POPUP = {
  SETUP: {
    title: 'Highlights',
    description:
      'Create a quick summary view based on information that you find valuable. Curate data from MAP, CRM and Zoominfo Intelligence.',
  },
  SUCCESSFUL: {
    title: 'Highlights Successfully Setup',
    description:
      'Highlights have been configured and will begin populating in your Highlights tab.',
  },
};

export const CS_DASHBOARD = {
  ALERTS: {
    CREATE_NEW_CUSTOM_FIELD_SUCCESS: 'New custom field created successfully',
    CHANGE_CHAT_WRITE_BACK_SUCCESS: 'Changed chat write back successfully',
    INTEGRATION_DISCONNECTED_SUCCESS: 'Integration disconnected successfully',
    MARKETO_WRITE_BACK_SUCCESS: 'Marketo write back updated successfully',
    MEETING_ADDRESS_UPDATED_SUCCESS: 'Meeting address updated successfully',
    UPDATE_POWERED_BY_ZI_SUCCESS: 'Updated powered by zi chat successfully',
    USER_UNLOCKED_SUCCESS: 'User unlocked successfully',
    DELETE_CUSTOM_FIELD: 'Custom field deleted successfully',
  },
};

export const ERROR_MESSAGES = {
  FIELD_EMPTY: 'This field cannot be empty',
  GREETING_MESSAGE_EMPTY: 'Unable to save. You must select a GIF or add a message before you save.',
};

export const BUTTON = {
  CLICK_HERE: 'Click here',
  VIEW_HOLIDAY_CONVERSATION: ' to view holiday conversation',
  SAVE_HOLIDAY: 'Save holiday',
};

export const UI_TEXT = {
  EMPTY: "Oh no! We couldn't find a single gif matching your search",
  REPLACE: 'Do you wanna replace the existing gif?',
};
